import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {StudentModel} from '../../../../models/authentication/student.model';
import {UserModel} from '../../../../models/authentication/user.model';
import {TokenModel} from '../../../../models/authentication/token.model';
import {AuthService} from '../../../../services/auth.service';
import {CultureModel} from '../../../../models/localization-and-pricing/culture.model';
import {SchoolModel} from '../../../../models/school/school.model';
import {StringExtensionModel} from '../../../../models/extensions/string-extension.model';
import {NavigationModel} from '../../../../models/localization-and-pricing/navigation.model';

@Component({
  selector: 'app-evo-sidebar',
  templateUrl: './platform-sidebar.component.html',
  styleUrls: ['./platform-sidebar.component.css']
})
export class PlatformSidebarComponent implements OnInit {

  constructor(private router: Router,
              private authSv: AuthService) { }

  ngOnInit() {
  }

  onDashboardClicked() {
    this.router.navigate(['platform', 'dash']);
  }


  onBooksClicked() {
    this.router.navigate(['platform', 'books']);
  }

  onAnswersClicked() {
    this.router.navigate(['platform', 'answers']);
  }

  onHelpClicked() {
    this.router.navigate(['platform', 'videos']);
  }

  onSettingsClicked() {
    this.router.navigate(['platform', 'settings', 'account']);
  }

  onLogoutClicked() {

    // Send a signout request.
    this.authSv.signOut().subscribe();
    if (CultureModel.getHomepageCulture()) {
      this.router.navigate(NavigationModel.getHomeURLPaths(['landing']));
    } else {
      this.router.navigate(['home', CultureModel.enGB, 'landing']);
    }

    UserModel.setCurrent( null );
    StudentModel.setCurrent( null );
    SchoolModel.setCurrent( null );
    TokenModel.setCurrent( null );

  }

}
